import {EventEmitter} from "pixi.js";

class EventsEmitter extends EventEmitter {
    constructor() {
        super();
    }

    onLoadApp(callback) {
        this.on('APP_IS_LOAD', callback)
    }

    emitLoadApp() {
        this.emit('APP_IS_LOAD')
    }

    onLoadToken(callback) {
        this.on('UPDATED_TOKEN_FROM_PARENT', callback)
    }

    emitLoadToken() {
        this.emit('UPDATED_TOKEN_FROM_PARENT')
    }

    emitSoundEvent(soundIsActive) {
        this.emit('SOUND_EVENT', soundIsActive)
    }

    onSoundEvent(callback) {
        this.on('SOUND_EVENT', callback)
    }

    emitScreenResizeEvent(obj) {
        this.emit('SCREEN_RESIZE_EVENT', obj)
    }

    onScreenResizeEvent(callback) {
        this.on('SCREEN_RESIZE_EVENT', callback)
    }

    onGameDataChange(callback) {
        this.on('GAME_DATA_CHANGE', callback)
    }

    emitGameDataChange(data) {
        this.emit('GAME_DATA_CHANGE', data)
    }

    onBalanceChange(callback) {
        this.on('BALANCE_CHANGE', callback)
    }

    emitBalanceChange() {
        this.emit('BALANCE_CHANGE')
    }

    onBetChange(callback) {
        this.on('BET_CHANGE', callback)
    }

    emitBetChange(bet) {
        this.emit('BET_CHANGE', bet)
    }

    onStartGame() {
        this.on('START_GAME')
    }

    emitStartGame() {
        this.emit('START_GAME')
    }

    onPrizeCompleate(callback) {
        this.on('ON_PRIZE_COMPLETE', callback)
    }

    emitPrizeCompleate() {
        this.emit('ON_PRIZE_COMPLETE')
    }
}

export const Events = EventsEmitter;